import { Observable, Subject } from 'rxjs';
import {
  empty,
  fromEvent,
  from,
  interval,
  of,
} from 'rxjs';
import {
  concat,
  debounce,
  tap, // 'do' operator is now 'tap'
  filter,
  last,
  map,
  merge,
  multicast,
  observeOn,
  publish,
  sample,
  scan,
  takeUntil
} from 'rxjs/operators';
import { animationFrame } from 'rxjs';

// If you need to make these available globally
window.Rx = {
  Observable,
  Subject,
  empty,
  fromEvent,
  from,
  interval,
  of,
  animationFrame
};
